import React, { useRef, useState } from "react"

interface PricingTooltipProps {
  content: React.ReactNode
  children: React.ReactNode
}

export function PricingTooltip({ content, children }: PricingTooltipProps) {
  const [isVisible, setIsVisible] = useState(false)
  const tooltipRef = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)

  const handleMouseEnter = () => {
    setIsVisible(true)
  }

  const handleMouseLeave = () => {
    setIsVisible(false)
  }

  return (
    <div
      className="tw-relative tw-inline-block"
      ref={containerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div>{children}</div>
      {isVisible && (
        <div
          ref={tooltipRef}
          className="tw-absolute tw-leading-[2] tw-z-10 tw-left-1/2 tw-transform tw--translate-x-1/2 tw-bottom-full tw-mb-2 tw-w-64 tw-px-5 tw-py-2 tw-bg-primary tw-text-white tw-text-base tw-text-xs tw-font-bold tw-rounded-md"
        >
          {content}
          <div className="tw-absolute tw-top-full tw-left-1/2 tw-transform tw--translate-x-1/2 tw-w-2 tw-h-2 tw-bg-primary tw-rotate-45"></div>
        </div>
      )}
    </div>
  )
}
